<template>
	<div id="notificacao-listar">
		<ld-table
			tableQueryKey="tableNotificacaoListar"
			:getData="getNotificacoes"
			:columnDefs="columnDefs"
			loadingText="Aguarde. Estamos carregando as notificações"
		>
			<!-- # TODO colocar permissao certa -->
			<div
				class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
				v-if="$permissions.can('public')"
			></div>
		</ld-table>

		<popup-notificacao-ver
			:active.sync="popupVerNotificacao"
			:closed="haddlerFecharNotificacaoVer"
			:notificacao="notificacaoVer"
		/>
	</div>
</template>

<script>
import { mapActions } from "vuex";

// import avatarLeftIcon from "../../../components/ld-table/utils/avatarLeftIcon.js";
import dateFilter from "../../../components/ld-table/utils/dateFilter.js";
import actionButtons from "../../../components/ld-table/utils/actionButtons.js";
import tableCheckbox from "../../../components/ld-table/utils/checkbox.js";
import Colaborador from "../../../models/Colaborador";
import Notificacao from "../../../models/Notificacao";
import DateHelper from "../../../helpers/DateHelper";
import PopupNotificacaoVer from "../components/popup_notificacao_ver/PopupNotificacaoVer";

export default {
	name: "Notificacoes",
	data() {
		return {
			notificacaoVer: null,
			popupVerNotificacao: false,
			columnDefs: [
				{
					headerName: "Data",
					field: "created_at",
					cellRenderer: params => {
						return DateHelper.convertDate(
							params.data["criadoEm"],
							null,
							"DD/MM/YYYY [as] HH:mm"
						);
					},
					customFilter: dateFilter(),
					style: {
						"max-width": "157px",
						"min-width": "157px"
					}
				},
				{
					headerName: "Notificação",
					field: "assunto",
					style: {
						"min-width": "150px"
					}
				},
				{
					headerName: "Prazo",
					field: "prazo",
					cellRenderer: params => {
						return params.data["prazo"].titulo;
					},
					style: {
						"min-width": "150px"
					}
				},
				{
					headerName: "Visto",
					field: "lida",
					filterColumnDisabled: true,
					cellRenderer: tableCheckbox({
						change: this.marcarNotificacaoComoLida,
						field: "lida"
					}),
					filter: "select",
					filterSelectData: [
						{ text: "Todos", value: "" },
						{ text: "Sim", value: true },
						{ text: "Não", value: false }
					],
					style: {
						width: "70px",
						"max-width": "200px",
						"min-width": "120px"
					}
				},
				{
					headerName: "",
					field: "acaoButtons",
					filterColumnDisabled: true,
					cellRenderer: actionButtons([
						{
							name: "Ver",
							onclick: this.verNotificacao
						}
					]),
					filter: false,
					style: {
						width: "70px",
						"max-width": "200px",
						"min-width": "70px"
					}
				}
			]
		};
	},
	components: {
		PopupNotificacaoVer
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		}
	},
	methods: {
		async getNotificacoes(params) {
			const data = {
				data: [],
				count: 0
			};

			try {
				const colaborador = Colaborador.getColaborador();

				const {
					notificacoes,
					totalNotificacoes
				} = await Notificacao.getNotificacoes(
					this.empresaPk,
					colaborador.pk,
					params
				);

				data.data = notificacoes;
				data.count = totalNotificacoes;
			} catch (error) {
				console.error(error);
			}

			return data;
		},
		verNotificacao(data) {
			const ver = () => {
				this.notificacaoVer = data;
				this.popupVerNotificacao = true;
			};

			return ver;
		},
		haddlerFecharNotificacaoVer() {
			this.notificacaoVer = null;
			this.popupVerNotificacao = false;
		},
		async marcarNotificacaoComoLida(notificacao) {
			const loading = this.$vsloading({
				container: "#notificacao-listar",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				const colaborador = Colaborador.getColaborador();

				await Notificacao.marcarComoLida(
					this.empresaPk,
					colaborador.pk,
					notificacao
				);

				if (notificacao.lida) {
					this.removeUnreadNotification(notificacao);
				} else {
					this.addUnreadNotification(notificacao);
				}
			} catch (error) {
				console.error(error);
			} finally {
				loading.hide();
			}
		},
		...mapActions([
			"setBreadcrumb",
			"removeUnreadNotification",
			"addUnreadNotification"
		])
	},
	created() {
		this.setBreadcrumb({
			title: "Notificações",
			list: [{ name: "Notificações", active: true }]
		});
	}
};
</script>

<style lang="scss" src="./notificacao.scss"></style>
